import { render, staticRenderFns } from "./KpiTabel.vue?vue&type=template&id=5e6e71b1"
import script from "./KpiTabel.vue?vue&type=script&lang=js"
export * from "./KpiTabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports